/**
 * 승인(accept) 시 콘텐츠가 전부 사라지면 블록 자체도 함께 사라지는 "내용 단위" 노드 타입 — Word 미리보기의
 * 블록 숨김 경계(`_createPreviewDecoration`)와 같은 정본이다. 표(table·tableRow·tableCell) 같은
 * 구조 컨테이너는 숨기면(또는 지우면) 열 구조가 붕괴하므로 제외한다. 미리보기·계약서 검토 위험 카드·OFF Apply
 * 물질화가 모두 이 하나의 집합만 본다.
 *
 * bulletList·orderedList는 스키마상 `listItem+`(자식 listItem 최소 1개)을 요구한다 — 안의 마지막 listItem이
 * paragraph처럼 캐스케이드 제거되면 wrapper만 content: [] 로 남아 이 제약을 어긴다. table과 달리 이 wrapper는
 * "목록"이라는 내용 자체를 담는 컨테이너라 내용이 전부 사라지면 wrapper도 함께 사라지는 게 맞다(열 구조가 붕괴하는
 * table과 다른 경계).
 */
export const REMOVABLE_WHEN_EMPTY_BLOCK_TYPES: ReadonlySet<string> = new Set(['paragraph', 'listItem', 'numberingList', 'bulletList', 'orderedList']);

/**
 * 표(table·tableRow·tableCell)는 셀 안의 문단이 전부 사라져도 최소 block 자식 하나는 있어야 하는 스키마
 * 제약(`content: 'block+'`)이 있다 — 승인 시 사라지는 문단·리스트라도 이 컨테이너 조상 밑에서는 통째로 지우지
 * 않고 빈 블록으로 남긴다. `_hasStructuralContainerAncestor`(미리보기 블록 숨김)와 같은 경계다.
 */
export const STRUCTURAL_CONTAINER_BLOCK_TYPES: ReadonlySet<string> = new Set(['table', 'tableRow', 'tableCell']);
